export const DIFFICULTY_LEVELS = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const DIFFICULTY_LEVELS_LABEL = {
  [DIFFICULTY_LEVELS.LOW]: "Low",
  [DIFFICULTY_LEVELS.MEDIUM]: "Medium",
  [DIFFICULTY_LEVELS.HIGH]: "High",
};

export const STATUS_OPTIONS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];
